<!--  -->
<template>
  <div>
    <el-dialog
      :title="pageType == 1 ? '延时申请' : '手动签离'"
      :visible.sync="delayDialog"
      width="450px"
    >
      <el-form
        :model="delayFormData"
        :rules="delayRules"
        label-width="110px"
        ref="delayForm"
      >
        <el-form-item label="访问时间"
          >{{ time.enterTime }}~{{ time.exitTime }}</el-form-item
        >
        <el-form-item label="延时时间" prop="delayedTime" v-if="pageType == 1">
          <el-date-picker
            v-model="delayFormData.delayedTime"
            value-format="yyyy-MM-dd hh:mm:ss"
            type="datetime"
            placeholder="选择延时时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="延时理由" prop="delayedReason" v-if="pageType == 1">
          <el-input v-model="delayFormData.delayedReason" type="textarea"></el-input>
        </el-form-item>

        <el-form-item label="签离说明" prop="remark" v-if="pageType == 2">
          <el-input v-model="delayFormData.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleDelayCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirmDelay" v-if="pageType == 1"
          >确认</el-button
        >
        <el-button type="primary" @click="handleConfirmSign" v-if="pageType == 2"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  data() {
    return {
      pageType: 1,
      delayDialog: false,
      delayFormData: { delayedTime: "", delayedReason: "", remark: "" },
      time: {
        enterTime: "",
        exitTime: "",
      },
      delayRules: {
        delayedTime: [{ required: true, message: "请选择延时时间", trigger: "change" }],
        delayedReason: [{ required: true, message: "请输入延时理由", trigger: "change" }],
        remark: [{ required: true, message: "请输入签离说明", trigger: "change" }],
      },
    };
  },

  // components: {},

  // computed() {},

  // mounted() {},

  methods: {
    open(data, type = 1) {
      this.pageType = type;
      this.delayFormData.appointmentCode = data.appointmentCode;
      this.time = {
        enterTime: data.enterTime,
        exitTime: data.exitTime,
      };
      this.delayDialog = true;
    },
    handleConfirmSign() {
      this.$refs.delayForm.validate((val) => {
        if (val) {
          let params = {
            appointmentCode: this.delayFormData.appointmentCode,
            remark: this.delayFormData.remark,
            status: 7,
            type: "1",
          };
          this.$fetch(api.doApprovalVisitor, params).then((res) => {
            if (!res.success) {
              this.$message.error(res.msgContent);
            } else {
              this.$message.success("签离成功");
              this.handleDelayCancel();
              this.$emit("delayOk");
            }
            //   this.queryData();
          });
        }
      });
    },
    handleConfirmDelay() {
      this.$refs.delayForm.validate((val) => {
        if (val) {
          let param = { ...this.delayFormData };
          delete param.remark;
          this.$fetch(api.delayedVisitorApply, param).then((res) => {
            if (!res.success) {
              this.$message.error(res.msgContent);
            } else {
              this.$message.success("延时成功");
              this.handleDelayCancel();
              this.$emit("delayOk");
            }
            //   this.queryData();
          });
        }
      });
    },
    handleDelayCancel() {
      this.$refs.delayForm.resetFields();
      this.delayDialog = false;
    },
  },
};
</script>
<style lang="less" scoped></style>
